import React, { Component } from 'react'
import SimpleTabs from './components/PendingWithdrawalTabPanel';

class PendingWithdrawalTab extends Component {
    render() {
        return (
            <div>
              <SimpleTabs />
            </div>
        )
    }
}
  
export default PendingWithdrawalTab
  